// O GSAP e o plugin de rolagem, registrados UMA vez.
//
// `gsap.registerPlugin` precisa rodar antes do primeiro uso do
// `scrollTrigger`, e registrar duas vezes é inofensivo mas registrar ZERO
// vezes falha em silêncio: a animação acontece de imediato, sem esperar a
// rolagem, e ninguém associa isso a um registro faltando.
//
// Concentrar aqui também dá um lugar só para trocar a biblioteca, e deixa os
// utils de animação livres do import -- é por isso que eles recebem o `gsap`
// por parâmetro e têm teste sem carregar nada.

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export { gsap, ScrollTrigger };

export default gsap;
